import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import UpdateRecordButtonLayout from "../layout/UpdateRecordButtonLayout";
import AutoFormDialog from "../dialogTypes/AutoFormDialog";
import getSchema from './../../lib/api/getSchema';
import ActionButtonLayout from './../layout/ActionButtonLayout';

function TkTotalAmounCalculationconfirmCostUpdateRecordButton(props) {
    const { t } = useTranslation();

    const { id, schema, grid, refresh, onSuccess, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState();
    const [confirmCostSchema, setconfirmCostSchema] = useState();

    useEffect(() => {
        let mounted = true;

        (async () => {

            let schema = await getSchema("TkTotalAmountCalculation");

            if (mounted) {

                for (let column of schema.columns) {
                    column.hideInForm = true;
                    if (column.name === "confirmCost") {
                        column.hideInForm = false;
                    }
                }

                setconfirmCostSchema(schema);

            }

        })();

        return (() => {

            mounted = false;

        });

    }, []);

    const onOpen = () => {
        if (grid) {
            setFormData({ ...grid.selectedItems[0], factor: "select" });
        }

        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onUpdateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if (refresh) {
            refresh.refresh();
        }
    };

    return (
        <>
            <ActionButtonLayout onClick={onOpen} {...others}>{t("buttonName.confirmCostUpdate")}</ActionButtonLayout>
            <AutoFormDialog
                id={id + "update-dialog"}
                mode="edit"
                formId={id + "update-form"}
                title={confirmCostSchema ? t(`dialog.title.confirmCost.update`) : ""}
                schema={confirmCostSchema}
                initialData={formData}
                open={open}
                onClose={onClose}
                onSuccess={onUpdateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>
    );
}

export default TkTotalAmounCalculationconfirmCostUpdateRecordButton;
